const initialState = {
    captions: [],
    isCaptionsOpen: false,
};
export default function captionsReducer(state = initialState, { type, payload } = {}) {
    switch (type) {
        case 'CAPTIONS/SET_IS_CLOSED_CAPTIONS_OPEN':
            return {
                ...state,
                /**
                 * Every time we open/close the captions, we want to clear the captions
                 * array.
                 */
                captions: [],
                isCaptionsOpen: payload,
            };
        case 'CAPTIONS/SET_CAPTIONS':
            return {
                ...state,
                captions: payload,
            };
        case 'CAPTIONS/CLEAR_CAPTIONS':
            return {
                ...state,
                captions: [],
            };
        default:
            return state;
    }
}
